import type { ReactElement } from "react";
import { Icon } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";

const PrivcoLogoSolid = ({
  color = "white",
  ...props
}: IconProps): ReactElement => (
  <Icon viewBox="0 0 254 251" color={color} fill="currentColor" {...props}>
    <title>PrivCo Logo</title>
    <path d="M150.102 8.282L14.187 86.752c-7.81 4.51-10.487 14.495-5.98 22.303 4.509 7.808 14.495 10.482 22.305 5.973l135.915-78.47c7.81-4.51 10.487-14.495 5.979-22.303-4.508-7.808-14.494-10.482-22.304-5.973zM202.096 34.76L66.182 113.228c-7.81 4.51-10.488 14.495-5.98 22.303 4.509 7.808 14.495 10.482 22.305 5.973l135.914-78.47c7.811-4.51 10.488-14.495 5.98-22.303-4.508-7.808-14.494-10.482-22.305-5.973zM173.3 107.892l-135.914 78.47c-7.81 4.509-10.488 14.494-5.98 22.303 4.508 7.808 14.494 10.482 22.305 5.972l135.914-78.47c7.81-4.509 10.487-14.494 5.979-22.302-4.508-7.809-14.494-10.483-22.304-5.973zM223.499 135.406l-135.914 78.47c-7.81 4.509-10.487 14.495-5.98 22.303 4.508 7.808 14.495 10.482 22.305 5.973l135.914-78.47c7.811-4.51 10.488-14.495 5.98-22.303-4.508-7.808-14.494-10.482-22.305-5.973z" />
  </Icon>
);

export default PrivcoLogoSolid;
